import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {ApiService} from '../services/api.service';
import {MieterDaten} from '../models/mieter-daten.model';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private apiService: ApiService, private router: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const mieterDaten: MieterDaten[] = this.apiService.currentMieterListValue;
    const accessGranted = mieterDaten !== null;
    if (!accessGranted) {
      await this.router.navigateByUrl('/login');
    }
    return accessGranted;
  }
}
